import { CanDeactivateFn } from '@angular/router';
import { TimesheetComponent } from '../components/timesheet/timesheet.component';

export const timesheetUnsavedGuard: CanDeactivateFn<TimesheetComponent> = (component) => {
  return component.canDeactivate();
};
